/* eslint-disable max-len */
import { applyMiddleware, createStore, compose } from 'redux';
import thunkMiddleware from 'redux-thunk/dist/redux-thunk';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { configurationIdForSelectionsMiddleware } from './middleware/plaConfigurationIdForSelections/plaConfigurationIdForSelections';
import { apiMiddleware } from './middleware/core/api';
import { localStoreChangeMiddleware } from './middleware/localStore/locaStoreChange';
import { analyticssMiddleware } from './middleware/core/analytics';
import rootReducer from '../reducers';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['persistedShapeinfo'],
};

let composeEnhancers;
if (typeof window !== 'undefined') {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
} else {
  composeEnhancers = compose;
}
export default function configureStore(preloadedState) {
  const middlewares = [thunkMiddleware, configurationIdForSelectionsMiddleware, apiMiddleware, localStoreChangeMiddleware, analyticssMiddleware];
  const middlewareEnhancer = applyMiddleware(...middlewares);

  const enhancers = [middlewareEnhancer];
  const composedEnhancers = composeEnhancers(...enhancers);

  const persistedReducer = persistReducer(persistConfig, rootReducer);
  const store = createStore(persistedReducer, preloadedState, composedEnhancers);
  const persistor = persistStore(store);

  return { store, persistor };
}
